<iframe id="token-iframe" frameborder="0" style="height: 220px; width: 100%;"></iframe>
<button class="btn-primary w-full" (click)="requestToken()" [ladda]="loading">SUBMIT</button>
